/* ============================================================
   ODEURS & PARFUMS — theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // --- Header scroll effect ---
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- Scroll animations (IntersectionObserver) ---
  const animatedEls = document.querySelectorAll('.fade-up, .fade-in, .stagger-children');
  if (animatedEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    animatedEls.forEach(el => observer.observe(el));
  }

  // --- Pop-up newsletter (délai 5s, stockage sessionStorage) ---
  const popup = document.getElementById('newsletter-popup');
  if (popup && !sessionStorage.getItem('popup_dismissed')) {
    const openPopup = () => {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
    };
    const closePopup = () => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      sessionStorage.setItem('popup_dismissed', '1');
    };

    // Ouvrir après 5 secondes
    setTimeout(openPopup, 5000);

    // Fermer via bouton ×
    const closeBtn = document.getElementById('popup-close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    // Fermer via backdrop
    const backdrop = popup.querySelector('.newsletter-popup__backdrop');
    if (backdrop) backdrop.addEventListener('click', closePopup);

    // Fermer via Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    // Fermer après soumission du formulaire
    const popupForm = document.getElementById('popup-newsletter-form');
    if (popupForm) {
      popupForm.addEventListener('submit', () => {
        setTimeout(closePopup, 1500);
      });
    }
  }

  // --- Reveal on scroll (sections hero, collections, philosophie, newsletter) ---
  const revealEls = document.querySelectorAll('.reveal-on-scroll');
  if (revealEls.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    revealEls.forEach(el => revealObserver.observe(el));
  }

  // --- Mobile menu toggle ---
  const toggle = document.querySelector('.header__toggle');
  const nav = document.querySelector('.header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('nav--open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  // --- Cart quantity controls ---
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    const input = btn.closest('.cart-item__quantity').querySelector('.cart-item__qty-val');
    if (!input) return;
    let val = parseInt(input.textContent) || 1;
    if (btn.dataset.qtyBtn === 'plus') val++;
    if (btn.dataset.qtyBtn === 'minus') val = Math.max(1, val - 1);
    input.textContent = val;
  });

  // --- Smooth anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // --- Product gallery thumbnails ---
  document.querySelectorAll('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.product-gallery__main');
      if (main) main.src = thumb.dataset.thumb;
      document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // --- Collection filters ---
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

});
